@charset "UTF-8";

/* app/js/src/components/clipping-studio/panels/thumbnail-tab/clipping-studio-thumbnail-tab.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.thumbnail-tab {
  position: relative;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding-bottom: 6rem;
  animation: thumbnail-fade-in 180ms ease;
}
.thumbnail-tab__sr-only-file {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
  opacity: 0;
}
.thumbnail-tab__section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.thumbnail-tab__label {
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.03em;
}
.thumbnail-tab__label-accent {
  text-transform: none;
  color: #2cbcfc;
  font-weight: 500;
}
.thumbnail-tab__select-wrap {
  position: relative;
}
.thumbnail-tab__select {
  width: 100%;
  padding: 12px 32px 12px 12px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 14px;
  font-weight: 500;
  border-radius: 12px;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(235, 240, 244);
  appearance: none;
  outline: none;
  cursor: pointer;
}
.thumbnail-tab__select:focus {
  box-shadow: 0 0 0 2px rgba(44, 188, 252, 0.25);
  background: rgb(255, 255, 255);
}
.thumbnail-tab__chevron {
  position: absolute;
  top: 50%;
  right: 12px;
  transform: translateY(-50%);
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
  pointer-events: none;
}
.thumbnail-tab__hint {
  margin: -2px 0 0;
  font-size: 12px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.54);
  display: flex;
  align-items: center;
  gap: 6px;
}
.thumbnail-tab__hint--accent {
  color: #2cbcfc;
}
.thumbnail-tab__section--clip-preview .thumbnail-tab__preview {
  animation: thumbnail-clip-preview-card-in 0.58s cubic-bezier(0.34, 1.18, 0.55, 1) both;
  transform-origin: center center;
}
.thumbnail-tab__section--clip-preview > .thumbnail-tab__btn--primary {
  animation: thumbnail-clip-preview-btn-in 0.48s cubic-bezier(0.22, 1, 0.36, 1) 0.22s both;
}
.thumbnail-tab__section--clip-preview > .thumbnail-tab__btn--secondary {
  animation: thumbnail-clip-preview-btn-in 0.48s cubic-bezier(0.22, 1, 0.36, 1) 0.4s both;
}
.thumbnail-tab__preview-shell {
  display: flex;
  justify-content: center;
  width: 100%;
}
.thumbnail-tab__preview {
  position: relative;
  width: 100%;
  max-width: 100%;
  border-radius: 6px;
  overflow: hidden;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(35, 47, 58);
  transition: transform 180ms ease;
}
.thumbnail-tab__preview:hover {
  transform: translateY(-1px) scale(1);
}
.thumbnail-tab__preview:hover .thumbnail-tab__preview-hover {
  opacity: 1;
}
.thumbnail-tab__preview--16-9 {
  aspect-ratio: 16/9;
}
.thumbnail-tab__preview--9-16 {
  aspect-ratio: 9/16;
  max-width: 200px;
}
.thumbnail-tab__preview--1-1 {
  aspect-ratio: 1;
  max-width: 230px;
}
.thumbnail-tab__preview--4-5 {
  aspect-ratio: 4/5;
  max-width: 230px;
}
.thumbnail-tab__preview--4-3 {
  aspect-ratio: 4/3;
}
.thumbnail-tab__preview--capturing {
  pointer-events: none;
}
.thumbnail-tab__capturing-overlay {
  position: absolute;
  inset: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(0, 0, 0, 0.55);
  color: #fff;
  padding: 12px;
  text-align: center;
}
.thumbnail-tab__capturing-spinner {
  width: 28px;
  height: 28px;
  border: 3px solid rgba(255, 255, 255, 0.25);
  border-top-color: #fff;
  border-radius: 50%;
  animation: thumbnail-tab-capturing-spin 0.8s linear infinite;
}
.thumbnail-tab__capturing-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.02em;
}
@keyframes thumbnail-tab-capturing-spin {
  to {
    transform: rotate(360deg);
  }
}
.thumbnail-tab__preview-hover {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.4);
  z-index: 3;
  opacity: 0;
  transition: opacity 180ms ease;
}
.thumbnail-tab__preview-hover-icon {
  width: 36px;
  height: 36px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.2);
  color: rgb(255, 255, 255);
  display: flex;
  align-items: center;
  justify-content: center;
  line-height: 0;
  -webkit-backdrop-filter: blur(2px);
  backdrop-filter: blur(2px);
  cursor: pointer;
  padding: 0;
}
.thumbnail-tab__preview-hover-icon:focus-visible {
  outline: 2px solid rgba(255, 255, 255, 0.85);
  outline-offset: 2px;
}
.thumbnail-tab__preview-hover-svg {
  width: 20px;
  height: 20px;
  flex-shrink: 0;
}
.thumbnail-tab__preview-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}
.thumbnail-tab__preview-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  color: rgba(0, 0, 0, 0.54);
  font-style: italic;
  background: rgb(235, 240, 244);
}
.thumbnail-tab__badge {
  position: absolute;
  right: 8px;
  bottom: 8px;
  background: rgba(0, 0, 0, 0.6);
  color: rgb(255, 255, 255);
  border-radius: 4px;
  font-size: 10px;
  line-height: 1;
  font-family: monospace;
  padding: 4px 6px;
  z-index: 4;
}
.thumbnail-tab__btn {
  border: 1px solid transparent;
  border-radius: 6px;
  padding: 11px 14px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition:
    background 120ms ease,
    transform 120ms ease,
    box-shadow 120ms ease;
}
.thumbnail-tab__btn:active {
  transform: translateY(1px);
}
.thumbnail-tab__btn:disabled {
  cursor: not-allowed;
  opacity: 0.45;
  transform: none;
}
.thumbnail-tab__btn--primary {
  background: #2cbcfc;
  color: rgb(255, 255, 255);
  box-shadow: 0 4px 10px rgba(44, 188, 252, 0.25);
}
.thumbnail-tab__btn--primary:hover:not(:disabled) {
  background: #29aae5;
}
.thumbnail-tab__btn--secondary {
  background: rgb(255, 255, 255);
  color: #2cbcfc;
  border: 2px solid #2cbcfc;
}
.thumbnail-tab__btn--secondary:hover:not(:disabled) {
  background: rgba(44, 188, 252, 0.08);
}
.thumbnail-tab__info {
  margin: 12px 0 0;
  padding: 8px 10px;
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  font-size: 12px;
  line-height: 1.4;
  color: rgba(0, 0, 0, 0.54);
  border: 1px solid rgba(45, 187, 252, 0.18);
  border-radius: 6px;
  background: rgba(45, 187, 252, 0.06);
}
.thumbnail-tab__btn-icon {
  flex-shrink: 0;
  display: block;
}
.thumbnail-tab__btn-icon--lucide {
  overflow: visible;
}
.thumbnail-image-preview {
  position: fixed;
  inset: 0;
  z-index: 220;
  display: flex;
  align-items: center;
  justify-content: center;
}
.thumbnail-image-preview__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.65);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
}
.thumbnail-image-preview__dialog {
  position: relative;
  width: min(920px, 100vw - 64px);
  max-height: calc(100vh - 64px);
  padding: 0;
  border-radius: 0;
  background: transparent;
  box-shadow: none;
}
.thumbnail-image-preview__close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 34px;
  height: 34px;
  border: none;
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.12);
  color: rgb(255, 255, 255);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}
.thumbnail-image-preview__canvas {
  width: 100%;
  max-height: calc(100vh - 120px);
  border-radius: 0;
  overflow: hidden;
  background: transparent;
}
.thumbnail-image-preview__img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}
.thumbnail-editor {
  position: fixed;
  inset: 0;
  z-index: 200;
  display: flex;
  align-items: center;
  justify-content: center;
}
.thumbnail-editor__backdrop {
  position: absolute;
  inset: 0;
  background: rgba(15, 23, 42, 0.42);
  backdrop-filter: blur(8px);
  -webkit-backdrop-filter: blur(8px);
  opacity: 0;
  animation: thumbnail-backdrop-in 120ms ease-out forwards;
  transition: opacity 180ms ease;
}
.thumbnail-editor__backdrop--closing {
  opacity: 0;
}
.thumbnail-editor__dialog {
  position: relative;
  width: min(1000px, 100vw - 16px);
  height: min(440px, 100vh - 72px);
  min-height: 0;
  background: rgb(255, 255, 255);
  font-family:
    "Open Sans",
    sans-serif,
    sans-serif;
  border-radius: 14px;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.3);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: scale(0.985) translateY(4px);
  opacity: 0;
  animation: thumbnail-dialog-in 180ms ease-out 90ms forwards;
  transition: transform 180ms ease, opacity 180ms ease;
}
.thumbnail-editor__dialog--ratio-9-16 {
  width: min(860px, 100vw - 16px);
  height: auto;
  max-height: calc(100vh - 40px);
}
.thumbnail-editor__dialog--ratio-9-16 .thumbnail-editor__body {
  grid-template-columns: minmax(140px, 1fr) minmax(250px, 320px) minmax(210px, 1fr);
}
.thumbnail-editor__dialog--ratio-1-1 {
  width: min(900px, 100vw - 16px);
  height: auto;
  max-height: calc(100vh - 56px);
}
.thumbnail-editor__dialog--ratio-1-1 .thumbnail-editor__body {
  grid-template-columns: minmax(145px, 1fr) minmax(300px, 380px) minmax(210px, 1fr);
}
.thumbnail-editor__dialog--ratio-4-5 {
  width: min(920px, 100vw - 16px);
  height: auto;
  max-height: calc(100vh - 48px);
}
.thumbnail-editor__dialog--ratio-4-5 .thumbnail-editor__body {
  grid-template-columns: minmax(145px, 1fr) minmax(280px, 350px) minmax(210px, 1fr);
}
.thumbnail-editor__dialog--ratio-4-3 {
  width: min(940px, 100vw - 16px);
  height: auto;
  max-height: calc(100vh - 52px);
}
.thumbnail-editor__dialog--ratio-4-3 .thumbnail-editor__body {
  grid-template-columns: minmax(145px, 1fr) minmax(320px, 410px) minmax(210px, 1fr);
}
.thumbnail-editor__dialog--closing {
  transform: scale(0.98);
  opacity: 0;
}
.thumbnail-editor__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px;
  border-bottom: 1px solid rgb(226, 232, 241);
}
.thumbnail-editor__title {
  margin: 0;
  font-size: 18px;
  font-weight: 700;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
}
.thumbnail-editor__close {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  background: transparent;
  color: rgba(0, 0, 0, 0.54);
  font-size: 24px;
  line-height: 1;
  cursor: pointer;
}
.thumbnail-editor__close:hover {
  background: rgba(0, 0, 0, 0.06);
}
.thumbnail-editor__body {
  padding: 16px 12px 10px;
  display: grid;
  grid-template-columns: minmax(150px, 1fr) minmax(350px, 480px) minmax(210px, 1fr);
  gap: 0;
  min-height: 0;
  flex: 1;
  overflow: hidden;
}
.thumbnail-editor__column {
  display: flex;
  flex-direction: column;
  gap: 8px;
  min-width: 0;
}
.thumbnail-editor__column--source {
  padding-right: 12px;
}
.thumbnail-editor__column--preview {
  padding: 0 12px;
}
.thumbnail-editor__column--controls {
  padding-left: 12px;
}
.thumbnail-editor__column--controls .thumbnail-editor__subtitle {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.06em;
  margin-bottom: 2px;
}
.thumbnail-editor__subtitle-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.thumbnail-editor__subtitle {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.54);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.thumbnail-editor__ratio {
  font-family: monospace;
  font-size: 10px;
  padding: 2px 6px;
  border-radius: 4px;
  background: rgb(235, 240, 244);
}
.thumbnail-editor__ghost-btn {
  width: 100%;
  padding: 8px 10px;
  border-radius: 6px;
  border: 1px solid rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.85);
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}
.thumbnail-editor__ghost-btn-icon {
  font-size: 13px;
  color: rgba(0, 0, 0, 0.54);
}
.thumbnail-editor__canvas-shell {
  background: transparent;
  border-radius: 0;
  padding: 2px 0 0;
  min-height: 0;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex: 1;
}
.thumbnail-editor__canvas {
  margin: 0;
  position: relative;
  border-radius: 10px;
  overflow: hidden;
  background: transparent;
  width: min(100%, 500px);
  border: 1px solid #0d2b5f;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab;
}
.thumbnail-editor__canvas--dragging {
  cursor: grabbing;
}
.thumbnail-editor__canvas--16-9 {
  aspect-ratio: 16/9;
  width: min(100%, 500px);
}
.thumbnail-editor__canvas--9-16 {
  aspect-ratio: 9/16;
  width: min(60%, 238px);
}
.thumbnail-editor__canvas--1-1 {
  aspect-ratio: 1;
  width: min(72%, 290px);
}
.thumbnail-editor__canvas--4-5 {
  aspect-ratio: 4/5;
  width: min(66%, 260px);
}
.thumbnail-editor__canvas--4-3 {
  aspect-ratio: 4/3;
  width: min(85%, 390px);
}
.thumbnail-editor__canvas-img {
  width: auto;
  height: auto;
  max-width: none;
  max-height: none;
  flex: 0 0 auto;
  transform-origin: center;
  -webkit-user-select: none;
  user-select: none;
  -webkit-user-drag: none;
  pointer-events: none;
}
.thumbnail-editor__canvas-img--fit-width {
  width: 100%;
  height: auto;
}
.thumbnail-editor__canvas-img--fit-height {
  width: auto;
  height: 100%;
}
.thumbnail-editor__canvas-placeholder {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}
.thumbnail-editor__crop-frame {
  display: none;
}
.thumbnail-editor__crop-handle {
  display: none;
}
.thumbnail-editor__field {
  display: flex;
  flex-direction: column;
  gap: 7px;
}
.thumbnail-editor__field-label {
  font-size: 10px;
  color: rgba(0, 0, 0, 0.54);
  font-weight: 700;
  line-height: 14px;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.thumbnail-editor__zoom-block {
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.thumbnail-editor__zoom-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.thumbnail-editor__field-label--zoom {
  margin: 0;
}
.thumbnail-editor__zoom-value {
  font-size: 12px;
  font-weight: 700;
  line-height: 14px;
  color: rgba(0, 0, 0, 0.54);
}
.thumbnail-editor__zoom-slider {
  --zoom-progress: 33%;
  width: 100%;
}
.thumbnail-editor__zoom-slider {
  flex: 1;
  min-width: 0;
  height: 8px;
  -webkit-appearance: none;
  appearance: none;
  background: transparent;
  border: none;
  outline: none;
}
.thumbnail-editor__zoom-slider::-webkit-slider-runnable-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.thumbnail-editor__zoom-slider::-webkit-slider-thumb {
  -webkit-appearance: none;
  appearance: none;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
  margin-top: -6px;
}
.thumbnail-editor__zoom-slider::-moz-range-track {
  height: 4px;
  background: #e1e6eb;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.thumbnail-editor__zoom-slider::-moz-range-thumb {
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: rgb(45, 187, 252);
  border: 2px solid rgb(255, 255, 255);
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.14);
  cursor: pointer;
}
.thumbnail-editor__zoom-slider::-webkit-slider-runnable-track {
  background:
    linear-gradient(
      to right,
      rgb(45, 187, 252) 0%,
      rgb(45, 187, 252) var(--zoom-progress),
      #e1e6eb var(--zoom-progress),
      #e1e6eb 100%);
}
.thumbnail-editor__zoom-slider::-moz-range-track {
  background: #e1e6eb;
}
.thumbnail-editor__zoom-slider::-moz-range-progress {
  background: rgb(45, 187, 252);
  height: 4px;
  border: 1px solid rgba(0, 0, 0, 0.14);
  border-radius: 2px;
}
.thumbnail-editor__select {
  width: 100%;
  border: 1px solid rgb(226, 232, 241);
  border-radius: 11px;
  background: rgb(235, 240, 244);
  min-height: 42px;
  appearance: none;
  cursor: pointer;
  padding: 9px 36px 9px 12px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  outline: none;
}
.thumbnail-editor__select:focus {
  box-shadow: 0 0 0 2px rgba(44, 188, 252, 0.25);
  background: rgb(255, 255, 255);
}
.thumbnail-editor__input {
  width: 100%;
  border: 1px solid rgb(226, 232, 241);
  border-radius: 8px;
  background: rgb(235, 240, 244);
  min-height: 34px;
  padding: 7px 10px;
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  outline: none;
}
.thumbnail-editor__input:focus {
  box-shadow: 0 0 0 2px rgba(44, 188, 252, 0.25);
  background: rgb(255, 255, 255);
}
.thumbnail-editor__link-btn {
  border: none;
  background: transparent;
  color: #2cbcfc;
  text-align: left;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  padding: 0;
  margin: 2px 0 4px;
  cursor: pointer;
}
.thumbnail-editor__divider {
  width: 100%;
  height: 1px;
  background: rgb(226, 232, 241);
  margin: 2px 0 4px;
}
.thumbnail-editor__footer {
  padding: 12px 12px;
  border-top: 1px solid rgb(226, 232, 241);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
}
.thumbnail-editor__footer-right {
  display: flex;
  align-items: stretch;
  gap: 8px;
}
.thumbnail-editor__btn {
  border-radius: 7px;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  padding: 8px 14px;
  cursor: pointer;
  border: 1px solid transparent;
  transition: background 120ms ease;
}
.thumbnail-editor__btn--cancel {
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.85);
  border-color: rgb(226, 232, 241);
}
.thumbnail-editor__btn--apply {
  background: #2cbcfc;
  color: rgb(255, 255, 255);
}
.thumbnail-editor__btn--apply:hover {
  background: #29aae5;
}
.thumbnail-editor__btn--icon {
  flex: 0 0 auto;
  width: auto;
  min-width: 0;
  height: auto;
  aspect-ratio: 1;
  padding: 0 10px;
  border-color: rgb(226, 232, 241);
  background: rgb(255, 255, 255);
  color: rgba(0, 0, 0, 0.54);
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.thumbnail-editor__btn--icon:hover {
  background: rgba(0, 0, 0, 0.04);
}
@keyframes thumbnail-fade-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes thumbnail-backdrop-in {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes thumbnail-dialog-in {
  from {
    opacity: 0;
    transform: scale(0.985) translateY(4px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}
/*# sourceMappingURL=clipping-studio-thumbnail-tab.component.css.map */
